// Mobile plan cards: opening one collapses the card that was open before.
up.compiler('.js-plan_cards_accordion', element => {
  const onClick = event => {
    const button = event.target.closest('.js-expandable__button')

    if (!button || button.getAttribute('aria-expanded') !== 'true') {
      return
    }

    element.querySelectorAll('.js-expandable__button[aria-expanded="true"]').forEach(other => {
      if (other !== button) {
        other.click()
      }
    })
  }

  element.addEventListener('click', onClick)

  return () => element.removeEventListener('click', onClick)
})
